/* ==========================================================================
   Craft Quest — Shop by Collection (collection page)
   Click a category circle → that collection's products load WITHOUT a page
   refresh, a loader is shown, and the URL becomes /collections/<handle>.
   Uses Shopify's Section Rendering API (?sections=) to re-render the
   collection-dependent sections (banner, grid…) of the target collection.
   Back / forward buttons are supported. Falls back to a normal page load if
   anything goes wrong (or the target collection uses another template).
   ========================================================================== */
(function () {
  if (window.__cqSbc) return;
  window.__cqSbc = true;

  var CQ = window.CQ = window.CQ || {};
  var MAX_SECTIONS = 5;      // Shopify limit for ?sections=
  var CACHE_MS = 60 * 1000;  // reuse a fetched collection for 60s
  var cache = {};
  var seq = 0;
  var hoverTimer;

  /* ---------- helpers ---------- */
  function normPath(p) {
    try { p = new URL(p, location.href).pathname; } catch (e) { /* keep */ }
    try { p = decodeURIComponent(p); } catch (e) { /* keep */ }
    return p.replace(/\/+$/, '').toLowerCase() || '/';
  }
  function strip() { return document.querySelector('[data-cq-sbc]'); }
  function grid() { return document.querySelector('[data-cq-collection]'); }
  function wrapperOf(el) { return el ? el.closest('.shopify-section') : null; }
  function idOf(wrapper) { return wrapper ? wrapper.id.replace(/^shopify-section-/, '') : null; }
  function currentPath() {
    var g = grid();
    return normPath(g && g.dataset.collectionUrl ? g.dataset.collectionUrl : location.pathname);
  }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }

  /* Sections to re-render: grid (required) + this strip (for meta) + other
     template sections in page order (banner etc.), max 5. */
  function sectionIds() {
    var gridId = idOf(wrapperOf(grid()));
    var stripId = idOf(wrapperOf(strip()));
    var ids = [];
    if (gridId) ids.push(gridId);
    if (stripId && ids.indexOf(stripId) === -1) ids.push(stripId);
    document.querySelectorAll('.shopify-section[id^="shopify-section-template--"]').forEach(function (w) {
      var id = idOf(w);
      if (ids.length < MAX_SECTIONS && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function cacheKey(u) { return normPath(u.pathname) + u.search; }

  function load(url) {
    var u = new URL(url, location.href);
    u.hash = '';
    u.searchParams.delete('sections');
    u.searchParams.delete('section_id');
    var key = cacheKey(u);
    var hit = cache[key];
    if (hit && Date.now() - hit.t < CACHE_MS) return hit.p;

    var ids = sectionIds();
    var f = new URL(u.toString());
    f.searchParams.set('sections', ids.join(','));
    var p = fetch(f.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (json) { return { ids: ids, sections: json || {} }; });
    p.catch(function () { if (cache[key] && cache[key].p === p) delete cache[key]; });
    cache[key] = { t: Date.now(), p: p };
    return p;
  }

  /* ---------- DOM swap ---------- */
  function loadedHrefs() {
    var set = {};
    document.querySelectorAll('link[rel="stylesheet"][href]').forEach(function (l) { set[l.href] = 1; });
    document.querySelectorAll('script[src]').forEach(function (s) { set[s.src] = 1; });
    return set;
  }
  function cloneScript(old) {
    var s = document.createElement('script');
    for (var i = 0; i < old.attributes.length; i++) s.setAttribute(old.attributes[i].name, old.attributes[i].value);
    s.text = old.text;
    return s;
  }
  function isAsset(n) {
    return n.nodeType === 1 && (n.tagName === 'SCRIPT' || (n.tagName === 'LINK' && /stylesheet/i.test(n.rel)));
  }

  /* Replace a section's content but keep already-loaded CSS/JS in place,
     so there is no flash of unstyled content and nothing runs twice. */
  function swapSection(oldW, newW) {
    var have = loadedHrefs();
    Array.prototype.slice.call(oldW.childNodes).forEach(function (n) { if (!isAsset(n)) oldW.removeChild(n); });
    Array.prototype.slice.call(newW.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'LINK' && /stylesheet/i.test(n.rel)) {
        if (!have[n.href]) oldW.appendChild(document.importNode(n, true));
        return;
      }
      if (n.nodeType === 1 && n.tagName === 'SCRIPT') {
        if (n.src && have[n.src]) return;
        oldW.appendChild(cloneScript(n));
        return;
      }
      oldW.appendChild(document.importNode(n, true));
    });
    oldW.className = newW.className;
  }

  function applyMeta(doc) {
    var m = doc.querySelector('[data-cq-sbc-meta]');
    if (!m) return;
    if (m.dataset.title) document.title = m.dataset.title;
    var d = document.querySelector('meta[name="description"]');
    if (d && m.dataset.description) d.setAttribute('content', m.dataset.description);
    if (m.dataset.url) {
      var abs = new URL(m.dataset.url, location.origin).toString();
      var c = document.querySelector('link[rel="canonical"]');
      if (c) c.setAttribute('href', abs);
      var og = document.querySelector('meta[property="og:url"]');
      if (og) og.setAttribute('content', abs);
    }
    var ogt = document.querySelector('meta[property="og:title"]');
    if (ogt && m.dataset.title) ogt.setAttribute('content', m.dataset.title);
  }

  function apply(res) {
    var parser = new DOMParser();
    var stripId = idOf(wrapperOf(strip()));
    res.ids.forEach(function (id) {
      var html = res.sections[id];
      if (typeof html !== 'string') return;
      var doc = parser.parseFromString(html, 'text/html');
      if (id === stripId) { applyMeta(doc); return; } // keep the parent's category strip
      var oldW = document.getElementById('shopify-section-' + id);
      var newW = doc.getElementById('shopify-section-' + id);
      if (oldW && newW) swapSection(oldW, newW);
    });
  }

  /* ---------- UI state ---------- */
  function setLoading(on, link) {
    var s = strip();
    if (s) {
      s.querySelectorAll('[data-cq-sbc-link].is-loading').forEach(function (a) { a.classList.remove('is-loading'); a.removeAttribute('aria-busy'); });
      if (on && link) { link.classList.add('is-loading'); link.setAttribute('aria-busy', 'true'); }
    }
    var g = grid();
    if (!g) return;
    var loader = g.querySelector(':scope > .cq-sbc-loader');
    if (on) {
      g.classList.add('cq-sbc-loading');
      g.setAttribute('aria-busy', 'true');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'cq-sbc-loader';
        loader.setAttribute('role', 'status');
        loader.setAttribute('data-cq-sbc-loader', '');
        loader.innerHTML = '<div class="cq-sbc-loader__box"><span class="cq-sbc-loader__spin" aria-hidden="true"></span><span class="cq-sbc-loader__text">Loading products…</span></div>';
        g.appendChild(loader);
      }
    } else {
      g.classList.remove('cq-sbc-loading');
      g.removeAttribute('aria-busy');
      if (loader) loader.remove();
    }
  }

  function markActive() {
    var s = strip(); if (!s) return;
    var cur = currentPath(), activeItem = null;
    s.querySelectorAll('[data-cq-sbc-link]').forEach(function (a) {
      var on = normPath(a.href) === cur;
      a.classList.toggle('is-active', on);
      if (on) { a.setAttribute('aria-current', 'page'); activeItem = a.closest('li'); }
      else a.removeAttribute('aria-current');
    });
    // keep the active circle visible in the horizontal (mobile) strip
    var list = s.querySelector('[data-cq-sbc-list]');
    if (activeItem && list && list.scrollWidth > list.clientWidth + 2) {
      var left = activeItem.offsetLeft - (list.clientWidth - activeItem.clientWidth) / 2;
      try { list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' }); } catch (e) { list.scrollLeft = left; }
    }
  }

  function afterSwap(gridId) {
    if (typeof CQ.collectionInit === 'function') CQ.collectionInit();
    else document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: gridId } }));
    document.dispatchEvent(new CustomEvent('cq:rendered'));
  }

  function keepInView() {
    var s = strip(), g = grid();
    if (!s || !g) return;
    if (g.getBoundingClientRect().top < 0) {
      var y = s.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
  }

  /* ---------- navigate ---------- */
  function go(url, push, link) {
    var target = new URL(url, location.href);
    var g = grid();
    if (!g || !wrapperOf(g)) { location.href = target.href; return; }
    var gridId = idOf(wrapperOf(g));

    var my = ++seq;
    setLoading(true, link);

    load(target.href)
      .then(function (res) {
        if (my !== seq) return;
        if (typeof res.sections[gridId] !== 'string') throw new Error('Collection uses another template');
        apply(res);
        if (push) history.pushState({ cqSbc: true }, '', target.pathname + target.search + target.hash);
        markActive();
        afterSwap(gridId);
        keepInView();
        document.dispatchEvent(new CustomEvent('cq:collection:change', { detail: { url: target.href } }));
      })
      .catch(function (err) {
        if (my !== seq) return;
        if (window.console) console.warn('[CQ] Shop by collection: falling back to page load', err);
        location.href = target.href;
      })
      .then(function () { if (my === seq) setLoading(false); });
  }

  function linkFrom(e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-cq-sbc-link]') : null;
    if (!a || !a.href) return null;
    if (designMode() || !grid() || !window.fetch || !(window.history && history.pushState)) return null;
    if (a.target && a.target !== '_self') return null;
    var u = new URL(a.href, location.href);
    return u.origin === location.origin ? a : null;
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var a = linkFrom(e);
    if (!a) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    // Already showing this collection with no filters → nothing to do
    if (normPath(a.href) === currentPath() && !location.search) { markActive(); return; }
    go(a.href, true, a);
  });

  // Prefetch on hover / touch / focus so the switch feels instant
  function prefetch(e) {
    var a = linkFrom(e);
    if (!a || normPath(a.href) === currentPath()) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { load(a.href).catch(function () {}); }, e.type === 'mouseover' ? 80 : 0);
  }
  document.addEventListener('mouseover', prefetch);
  document.addEventListener('focusin', prefetch);
  document.addEventListener('touchstart', prefetch, { passive: true });

  window.addEventListener('popstate', function () {
    if (!strip() || !grid()) return;
    // Same collection (filters / sort / page changed) → cq-collection.js handles it
    if (normPath(location.href) === currentPath()) return;
    go(location.href, false, null);
  });

  function init() { markActive(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(markActive, 0); });
})();
